import { render } from "./BodyPage.vue?vue&type=template&id=44a52fbc&scoped=true"
import script from "./BodyPage.vue?vue&type=script&lang=js"
export * from "./BodyPage.vue?vue&type=script&lang=js"

import "./BodyPage.vue?vue&type=style&index=0&id=44a52fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a52fbc"]])

export default __exports__